import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import {
  Box,
  Divider,
  Link,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FunctionComponent } from "react";
import { Contact } from "../types/contact";

interface Props {
  data: Contact;
}

const ContactCard: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const { data } = props;

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        width: "300px",
        height: "200px",
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center",
        padding: "10px",
      }}
    >
      {/* {data.avatar ? (
        <Avatar
          alt="photo of the contact"
          src={data.base64Photo}
          sx={{ width: 100, height: 100, margin: "10px" }}
        />
      ) : (
        <Avatar
          sx={{ width: 100, height: 100, margin: "10px", bgcolor: "lightgrey" }}
        >
          <PersonIcon sx={{ width: 90, height: 90 }} />
        </Avatar>
      )} */}

      <Typography variant="h6">{data.name}</Typography>

      <Typography variant="body2">{data.jobTitle}</Typography>

      <Box sx={{ width: "100%", pt: "10px" }}>
        <Stack direction={"row"} gap={"10px"} justifyContent={"start"}>
          <EmailIcon sx={{ color: 'rgba(0, 0, 0, 0.5)' }} />
          <Link href={`mailto:${data.email}`} variant="body2">
            {data.email}
          </Link>
        </Stack>

        <Stack
          direction={"row"}
          sx={{ pt: "5px" }}
          gap={"10px"}
          justifyContent={"start"}
        >
          <PhoneIcon sx={{ color: 'rgba(0, 0, 0, 0.5)' }} />
          <Link href={`tel:${data.contactNumber}`} variant="body2">
            {data.contactNumber}
          </Link>
        </Stack>
      </Box>
      {isSmallScreen && <Divider sx={{ p: "10px", width: "300px" }} />}
    </Box>
  );
};

export default ContactCard;
